import { FoodSteakOffIcon } from './FoodSteakOffIcon';

/**
 * author: Michael Irigoyen
 * id A0482E2B-FA1E-4478-BA16-A7EF749920B3
 * name food-steak-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-steak-off.svg
 * tags
 * - Food / Drink 
 */
export const BeefOffIcon = FoodSteakOffIcon;
export default BeefOffIcon